<div class="screen has-tabbar">
  <div class="screen-inner">
    <app-shell nav="back" action="menu" [title]="leagueName" [backTo]="['/leagues']"></app-shell>

    @if (logoImageUrl || seasons.length > 0) {
      <div class="league-head">
        @if (logoImageUrl) {
          <img class="avatar avatar-logo" [src]="logoImageUrl" alt="" (error)="logoImageUrl = ''" />
        }
        @if (seasons.length > 0) {
          <div class="season-picker">
            <select [ngModel]="seasonId" (ngModelChange)="changeSeason($event)" aria-label="Season">
              @for (season of seasons; track season.id) {
                <option [ngValue]="season.id">{{ season.name }}</option>
              }
            </select>
          </div>
        }
      </div>
    }

    @switch (tab) {
      @case ('events') {
        @if (liveEvent) {
          <section class="hero">
            <span class="pill">Live now</span>
            <h2 class="hero-title">{{ liveEvent.name }}</h2>
            <p class="hero-meta">{{ eventMeta(liveEvent) }}</p>
            <a class="hero-link" [routerLink]="['/events', liveEvent.id]">View leaderboard &#8250;</a>
          </section>
        }

        <p class="section-label">Upcoming events</p>
        @if (upcoming.length === 0) {
          <p class="page-note">No events scheduled yet.</p>
        } @else {
          <div class="card">
            @for (event of upcoming; track event.id) {
              <a class="row" [routerLink]="['/events', event.id]">
                <span class="row-body">
                  <span class="row-title">{{ event.name }}</span>
                  <span class="row-meta">{{ eventMeta(event) }}</span>
                </span>
                <span class="chevron">&#8250;</span>
              </a>
            }
          </div>
        }

        @if (past.length > 0) {
          <p class="section-label">Finished</p>
          <div class="card">
            @for (event of past; track event.id) {
              <a class="row" [routerLink]="['/events', event.id]">
                <span class="row-body">
                  <span class="row-title">{{ event.name }}</span>
                  <span class="row-meta">{{ eventMeta(event) }}</span>
                </span>
                <span class="pill pill-muted">Done</span>
                <span class="chevron">&#8250;</span>
              </a>
            }
          </div>
        }
      }

      @case ('money') {
        @if (money) {
          <p class="section-label">{{ seasonName() }}</p>
          <div class="card">
            @for (row of money.season; track row.userId) {
              <div class="lb-item">
                <button type="button" class="row" [class.row-static]="row.lines.length === 0" (click)="toggleMoney('season', row)">
                  @if (moneyFaces) {
                    <span class="face-slot">
                      <app-face [urls]="row.profilePictureUrl ? [row.profilePictureUrl] : []"></app-face>
                    </span>
                  }
                  <span class="row-body">
                    <span class="row-title">{{ row.displayName }}</span>
                  </span>
                  <span class="money-total" [class.money-none]="row.total <= 0">{{ moneyLabel(row.total) }}</span>
                </button>
                @if (moneyOpen('season', row)) {
                  <div class="money-lines" [class.money-lines-name]="moneyFaces">
                    @for (line of row.lines; track $index) {
                      <div class="money-line">
                        <span>{{ line.eventName }} · {{ line.label }}</span>
                        <span>{{ formatMoney(line.amount) }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>

          <p class="section-label">All time</p>
          <div class="card">
            @for (row of money.allTime; track row.userId) {
              <div class="lb-item">
                <button type="button" class="row" [class.row-static]="row.lines.length === 0" (click)="toggleMoney('all', row)">
                  @if (moneyFaces) {
                    <span class="face-slot">
                      <app-face [urls]="row.profilePictureUrl ? [row.profilePictureUrl] : []"></app-face>
                    </span>
                  }
                  <span class="row-body">
                    <span class="row-title">{{ row.displayName }}</span>
                  </span>
                  <span class="money-total" [class.money-none]="row.total <= 0">{{ moneyLabel(row.total) }}</span>
                </button>
                @if (moneyOpen('all', row)) {
                  <div class="money-lines" [class.money-lines-name]="moneyFaces">
                    @for (line of row.lines; track $index) {
                      <div class="money-line">
                        <span>{{ line.eventName }} · {{ line.label }}</span>
                        <span>{{ formatMoney(line.amount) }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      }

      @case ('players') {
        <p class="section-label">{{ members.length }} players</p>
        <div class="card">
          @for (member of members; track member.userId) {
            <div class="row row-static">
              @if (hasFaces) {
                <span class="face-slot">
                  <app-face [urls]="member.profilePictureUrl ? [member.profilePictureUrl] : []"></app-face>
                </span>
              }
              <span class="row-body">
                <span class="row-title">{{ member.displayName }}</span>
                <span class="row-meta">{{ member.role }} · {{ formatIndex(member.handicapIndex) }} index</span>
              </span>
            </div>
          }
        </div>
      }
    }

    @if (error) { <p class="error">{{ error }}</p> }
  </div>

  <nav class="tabbar">
    <div class="tabbar-inner">
      <a [routerLink]="['/leagues', leagueId]" [class.active]="tab === 'events'">Events</a>
      <a [routerLink]="['/leagues', leagueId]" [queryParams]="{ tab: 'money' }" [class.active]="tab === 'money'">Money List</a>
      <a [routerLink]="['/leagues', leagueId]" [queryParams]="{ tab: 'players' }" [class.active]="tab === 'players'">Players</a>
    </div>
  </nav>
</div>
